import React from 'react'
import PropTypes from 'prop-types'

function SidebarMenuItem (props) {
  const classNames = [
    'group',
    'flex',
    'items-center',
    'py-3',
    'px-8',
    'text-sm',
    'leading-5',
    'font-medium',
    'text-gray-700',
    'hover:text-gray-800',
    'hover:bg-gray-100',
    'focus:outline-none',
    'transition',
    'ease-in-out',
    'duration-150',
    'cursor-pointer',
    'w-full',
    'relative'
  ]

  const iconClassNames = [
    'mr-3',
    'h-6',
    'w-6',
    'text-gray-400',
    'group-hover:text-gray-500',
    'group-focus:text-gray-500',
    'transition',
    'ease-in-out',
    'duration-150'
  ]

  const statusBarClassNames = [
    'w-1',
    'h-full',
    'absolute',
    'top-0',
    'left-0'
  ]

  if (props.active === true) {
    if (props.hasActiveBg === true) {
      classNames.push('bg-gray-200')
    }

    classNames.push('text-gray-900')
    iconClassNames.push('text-primary-500')
    iconClassNames.push('group-focus:text-primary-500')
    statusBarClassNames.push('bg-primary-500')
  }

  const icon = props.svgIcon ? (
    <div className={iconClassNames.join(' ')}>{props.svgIcon}</div>) : null

  return (
    <div onClick={props.onClick} className={classNames.join(' ')}>
      {props.hasStatusBar ? <div
        className={statusBarClassNames.join(' ')}
                            /> : null}
      {icon}
      {props.text}
    </div>
  )
}

SidebarMenuItem.defaultProps = {
  active: false,
  hasStatusBar: true,
  hasActiveBg: true
}

SidebarMenuItem.propTypes = {
  /**
   * Set to true to make menu item active
   */
  active: PropTypes.bool,
  /**
   * Menu item text
   */
  text: PropTypes.string,
  /**
   * SVG paths for menu icon
   */
  svgIcon: PropTypes.node,
  /**
   * Contols the status bar on the left side
   * of the menu item (visible on active item)
   */
  hasStatusBar: PropTypes.bool,
  /**
   * Controls if the active menu item should have
   * a different background color
   */
  hasActiveBg: PropTypes.bool,
  /**
   * onClick method
   */
  onClick: PropTypes.func
}

export default SidebarMenuItem
